import type { NoveltyFront } from "@tential/ec-gql-schema/models/novelty"
import dayjs from "dayjs"

export const useNovelty = () => {
  type Product = { document_id: string; novelty_start_unixtime?: number; novelty_end_unixtime?: number }

  /**
   * 指定した商品が対象となっているノベルティキャンペーンを取得する
   */
  const getNoveltiesForProduct = async (product: Product | Product[]): Promise<NoveltyFront[]> => {
    const now = dayjs().unix() * 1000
    const isTarget = (product: Product) => {
      return (
        product.novelty_start_unixtime &&
        product.novelty_start_unixtime < now &&
        product.novelty_end_unixtime &&
        product.novelty_end_unixtime > now
      )
    }
    let productIds: string[] = []
    if (Array.isArray(product)) {
      productIds = product.filter((p) => isTarget(p)).map((p) => p.document_id)
    } else if (isTarget(product)) {
      productIds = [product.document_id]
    }
    if (!productIds.length) {
      return []
    }

    let novelties: NoveltyFront[] = []
    try {
      const res = await $fetch<ApiDataResponse<NoveltyFront>>(`/api/data/products/novelties`, {
        method: "POST",
        body: JSON.stringify({ productIds }),
      })
      novelties = res.items
    } catch (e) {
      console.error(e)
    }
    return novelties
  }

  return {
    getNoveltiesForProduct,
  }
}
